import { FC } from "react";

import IconProps from "./IconProps";

const PinFilledIcon: FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17316_915)">
      <path
        d="M10.0753 2.14005L10.1379 2.19538L13.8046 5.86205C13.917 5.97503 13.9852 6.12453 13.9968 6.28347C14.0085 6.4424 13.9628 6.60025 13.8681 6.72841C13.7734 6.85657 13.6359 6.94656 13.4805 6.98209C13.3252 7.01761 13.1623 6.99631 13.0213 6.92205L10.9066 9.03605L9.95726 11.5674C9.93225 11.6342 9.89669 11.6965 9.85192 11.752L9.80526 11.8054L8.80526 12.8054C8.69038 12.9201 8.5376 12.9889 8.37558 12.999C8.21357 13.009 8.05345 12.9596 7.92526 12.86L7.86192 12.8047L5.99992 10.9434L3.47126 13.4714C3.35128 13.5909 3.1903 13.6604 3.021 13.6655C2.8517 13.6707 2.68678 13.6112 2.55974 13.4992C2.43269 13.3872 2.35305 13.231 2.33699 13.0624C2.32093 12.8938 2.36965 12.7254 2.47326 12.5914L2.52859 12.5287L5.05659 10L3.19526 8.13805C3.08047 8.02325 3.01152 7.87052 3.00133 7.7085C2.99114 7.54648 3.04042 7.38632 3.13992 7.25805L3.19526 7.19538L4.19526 6.19538C4.24556 6.1449 4.30363 6.10281 4.36726 6.07071L4.43259 6.04271L6.96326 5.09271L9.07726 2.97938C9.00517 2.8446 8.98158 2.68914 9.01045 2.53905C9.03932 2.38895 9.11888 2.25334 9.23582 2.15491C9.35276 2.05649 9.49997 2.00123 9.65279 1.99841C9.80561 1.99558 9.95476 2.04601 10.0753 2.14005Z"
        fill="#627293"
      />
    </g>
    <defs>
      <clipPath id="clip0_17316_915">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PinFilledIcon;
